
    import './styles.scoped.css';
    export default {
  "tabs-header": "awsui_tabs-header_14rmt_bm9ql_10",
  "tabs-header-list": "awsui_tabs-header-list_14rmt_bm9ql_16",
  "pagination-button": "awsui_pagination-button_14rmt_bm9ql_34",
  "pagination-button-left": "awsui_pagination-button-left_14rmt_bm9ql_39",
  "pagination-button-left-scrollable": "awsui_pagination-button-left-scrollable_14rmt_bm9ql_42",
  "pagination-button-right": "awsui_pagination-button-right_14rmt_bm9ql_46",
  "pagination-button-right-scrollable": "awsui_pagination-button-right-scrollable_14rmt_bm9ql_49",
  "tabs-tab": "awsui_tabs-tab_14rmt_bm9ql_54",
  "tabs-tab-label": "awsui_tabs-tab-label_14rmt_bm9ql_66",
  "tabs-tab-link": "awsui_tabs-tab-link_14rmt_bm9ql_82",
  "tabs-tab-disabled": "awsui_tabs-tab-disabled_14rmt_bm9ql_139",
  "tabs-tab-active": "awsui_tabs-tab-active_14rmt_bm9ql_168",
  "tabs-header-with-divider": "awsui_tabs-header-with-divider_14rmt_bm9ql_175",
  "root": "awsui_root_14rmt_bm9ql_179",
  "tabs": "awsui_tabs_14rmt_bm9ql_10",
  "tabs-content-wrapper": "awsui_tabs-content-wrapper_14rmt_bm9ql_195",
  "with-paddings": "awsui_with-paddings_14rmt_bm9ql_195",
  "tabs-container-content-wrapper": "awsui_tabs-container-content-wrapper_14rmt_bm9ql_199",
  "tabs-content": "awsui_tabs-content_14rmt_bm9ql_195",
  "tabs-content-active": "awsui_tabs-content-active_14rmt_bm9ql_207"
};
  